<app-loader></app-loader>

<div class="main-container-v2 v2-active">
    <app-campaign-ticker></app-campaign-ticker>

    <app-v2-shell-header
        [nomeCliente]="nomeCliente"
        [isAdm]="isAdm"
        [ratoeiraHubUrl]="ratoeiraHubUrl"
        [showMenuToggle]="!hideShellSidenav"
        (menuToggle)="onHeaderMenuToggle()"
        (toggleAi)="toggleAiSideSheet()"
    ></app-v2-shell-header>

    <div class="main-layout">
        <mat-sidenav-container
            class="shell-sidenav-container"
            [class.shell-sidenav-container--collapsed]="layoutStore.isCollapsed && layoutStore.isDesktop"
            autosize
        >
            @if (!hideShellSidenav) {
                <mat-sidenav
                    #sidenav
                    class="shell-sidenav"
                    [mode]="getSidenavMode()"
                    [opened]="isSidenavOpened"
                    [class.collapsed]="layoutStore.isCollapsed && layoutStore.isDesktop"
                    [disableClose]="false"
                    (opened)="onSidenavOpened()"
                    (closed)="onSidenavClosed()"
                >
                    <app-v2-shell-sidebar
                        [isAdm]="isAdm"
                        [habilitarGerenciadorAnuncios]="habilitarGerenciadorAnuncios"
                        (closeSidebar)="sidenav.close()"
                        (toggleAi)="toggleAiSideSheet()"
                    ></app-v2-shell-sidebar>
                </mat-sidenav>
            }

            <mat-sidenav-content class="shell-content">
                <main class="content-area">
                    <div class="content-container">
                        @if (breadcrumbItems.length > 0) {
                            <app-page-breadcrumb [items]="breadcrumbItems"></app-page-breadcrumb>
                        }
                        <router-outlet></router-outlet>
                    </div>
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</div>

<app-gitbook-ai-embed></app-gitbook-ai-embed>

@if (gitbookAiEmbed?.isWidgetOpen) {
    <button class="close-chat-float-btn" (click)="toggleAiSideSheet()">
        {{ 'menu.closeChat' | transloco }}
    </button>
}
